module.exports = __webpack_public_path__ + "img/twenty-four.39bb5078.png";